export enum TechnicianImpactReason {
  LOCATION_UPDATE = 'location_update',
  MODE_UPDATE = 'mode_update',
  TIME_REDUCTION = 'time_reduction',
  DAY_ELIMINATION = 'day_elimination',
  MANUAL_OVERRIDE_CONFLICT = 'manual_override_conflict',
  MANUAL_OVERRIDE_INFO = 'manual_override_info',
}
